/* Variant King combined listings (product + collection swatches).
   App JS (generateUI) handles arrows on keyup — not keydown — then
   treats Arrow like a click and assigns swatch-url. Stop Arrow/Home/
   End on both phases so arrows only move the radio; let Space/Enter
   keyup reach the app so it can commit. Tab leaves the group. */
(function () {
  var LISTING_SEL = 'variant-king-combined-listing';
  var GROUP_SEL = 'ul.swatch-view, [role="radiogroup"], .swatch-navigable, .swatch-single';
  var ITEM_SEL = 'li.swatch-view-item, li[role="radio"]';
  var ITEM_FALLBACK_SEL = [
    '.swatch-image-wrapper',
    '.swatch-view [tabindex]',
    '[role="radio"]',
    '[role="option"]'
  ].join(',');
  var PAGE_FOCUSABLE = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([type="hidden"]):not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex^="-"])'
  ].join(',');

  function isVisible(el) {
    if (!(el instanceof Element)) return false;
    if (el.hasAttribute('disabled') || el.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return el.getClientRects().length > 0;
  }

  function listingOf(el) {
    return el && el.closest ? el.closest(LISTING_SEL) : null;
  }

  function groupOf(el) {
    if (!(el instanceof Element)) return null;
    return el.closest('ul.swatch-view, [role="radiogroup"]') ||
      el.closest('.swatch-navigable, .swatch-single, [id^="swatch-group"]') ||
      listingOf(el);
  }

  function itemsIn(group) {
    if (!group) return [];
    var nodes = group.querySelectorAll(ITEM_SEL);
    if (!nodes.length) nodes = group.querySelectorAll(ITEM_FALLBACK_SEL);
    var seen = [];
    Array.prototype.forEach.call(nodes, function (el) {
      if (!isVisible(el)) return;
      if (el.matches('input[type="radio"]')) return;
      if (seen.indexOf(el) !== -1) return;
      if (seen.some(function (other) { return other.contains(el) || el.contains(other); })) {
        return;
      }
      seen.push(el);
    });
    return seen;
  }

  function itemOf(el) {
    if (!(el instanceof Element)) return null;
    return el.closest(ITEM_SEL) || el.closest(ITEM_FALLBACK_SEL);
  }

  function isSelected(el) {
    return !!(
      el.getAttribute('aria-checked') === 'true' ||
      el.classList.contains('swatch-selected') ||
      el.querySelector('.swatch-selected, [current-product]')
    );
  }

  function committedItem(group) {
    if (!group) return null;
    if (group._lfCommitted && group.contains(group._lfCommitted)) return group._lfCommitted;
    return itemsIn(group).find(isSelected) || null;
  }

  function rememberCommitted(group) {
    if (!group) return;
    var selected = itemsIn(group).find(isSelected);
    if (selected) group._lfCommitted = selected;
  }

  function restoreChecked(group) {
    var committed = committedItem(group);
    if (!committed) return;
    itemsIn(group).forEach(function (el) {
      if (!el.hasAttribute('aria-checked') && el.getAttribute('role') !== 'radio') return;
      el.setAttribute('aria-checked', el === committed ? 'true' : 'false');
    });
  }

  function syncTabStops(group, focused) {
    var items = itemsIn(group);
    if (!items.length) return;
    var current = focused || committedItem(group) || items[0];
    items.forEach(function (el) {
      el.tabIndex = el === current ? 0 : -1;
    });
    restoreChecked(group);
  }

  function focusItem(item) {
    if (!item) return;
    item.tabIndex = 0;
    item.focus();
  }

  function moveFocus(group, delta) {
    var items = itemsIn(group);
    if (!items.length) return;
    var index = items.indexOf(itemOf(document.activeElement));
    if (index < 0) index = items.findIndex(function (el) { return el.tabIndex === 0; });
    if (index < 0) index = 0;
    var next = items[(index + delta + items.length) % items.length];
    syncTabStops(group, next);
    focusItem(next);
  }

  function pageFocusables() {
    return Array.prototype.filter.call(document.querySelectorAll(PAGE_FOCUSABLE), isVisible);
  }

  function focusOutside(container, reverse) {
    var outside = pageFocusables().filter(function (el) {
      return !container.contains(el);
    });
    if (!outside.length) return;
    if (!reverse) {
      var after = outside.find(function (el) {
        return container.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING;
      });
      (after || outside[0]).focus();
      return;
    }
    var before = null;
    for (var i = 0; i < outside.length; i++) {
      if (container.compareDocumentPosition(outside[i]) & Node.DOCUMENT_POSITION_PRECEDING) {
        before = outside[i];
      }
    }
    (before || outside[outside.length - 1]).focus();
  }

  function isBrowseKey(event) {
    var key = event.key;
    var code = event.code;
    return key === 'ArrowRight' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowUp' ||
      key === 'Home' || key === 'End' ||
      code === 'ArrowRight' || code === 'ArrowDown' || code === 'ArrowLeft' || code === 'ArrowUp' ||
      code === 'Home' || code === 'End';
  }

  function isCommitKey(event) {
    var key = event.key;
    var code = event.code;
    return key === ' ' || key === 'Spacebar' || key === 'Enter' ||
      code === 'Space' || code === 'Enter';
  }

  function enhance(listing) {
    if (!(listing instanceof Element)) return;
    listing.querySelectorAll(GROUP_SEL).forEach(function (group) {
      rememberCommitted(group);
      syncTabStops(group);
    });
  }

  function scan() {
    document.querySelectorAll(LISTING_SEL).forEach(enhance);
  }

  function onKey(event) {
    var listing = listingOf(event.target);
    if (!listing) return;
    var group = groupOf(event.target) || listing;
    var item = itemOf(event.target);
    var key = event.key;

    if (key === 'Tab') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type === 'keydown') focusOutside(listing, event.shiftKey);
      return;
    }

    if (isBrowseKey(event)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type !== 'keydown') {
        restoreChecked(group);
        return;
      }
      rememberCommitted(group);
      if (key === 'ArrowRight' || key === 'ArrowDown' || event.code === 'ArrowRight' || event.code === 'ArrowDown') {
        moveFocus(group, 1);
      } else if (key === 'ArrowLeft' || key === 'ArrowUp' || event.code === 'ArrowLeft' || event.code === 'ArrowUp') {
        moveFocus(group, -1);
      } else if (key === 'Home' || event.code === 'Home') {
        syncTabStops(group, itemsIn(group)[0]);
        focusItem(itemsIn(group)[0]);
      } else if (key === 'End' || event.code === 'End') {
        var items = itemsIn(group);
        syncTabStops(group, items[items.length - 1]);
        focusItem(items[items.length - 1]);
      }
      restoreChecked(group);
      return;
    }

    if (isCommitKey(event)) {
      event.preventDefault();
      if (event.type === 'keydown') return;
      if (item) group._lfCommitted = item;
    }
  }

  window.addEventListener('keydown', onKey, true);
  window.addEventListener('keyup', onKey, true);

  document.addEventListener(
    'click',
    function (event) {
      var listing = listingOf(event.target);
      if (!listing) return;
      var group = groupOf(event.target);
      var item = itemOf(event.target);
      if (group && item) group._lfCommitted = item;
    },
    true
  );

  window.lfA11y.once(scan);
})();

/* REMOVED: Screen reader does not announce “Login Required, dialog” when the dialog receives focus
   99minds Headless UI portal. A document-wide observer was required because the widget
   rewrites role/name on every render; that stalled the storefront. File with 99minds. */

/* "Sort By" combo box is missing its label and is announced as a button */
(function () {
  var FOCUS_CLASS = 'is-focused';

  function nameCombo(combo) {
    if (combo.getAttribute('role') !== 'combobox') combo.setAttribute('role', 'combobox');
    if (!combo.getAttribute('aria-haspopup')) combo.setAttribute('aria-haspopup', 'listbox');
    var heading = document.getElementById('sort-dropdown-heading');
    if (heading) {
      var labelledby = combo.getAttribute('aria-labelledby') || '';
      if (labelledby.indexOf(heading.id) === -1) {
        combo.setAttribute('aria-labelledby', (heading.id + ' ' + labelledby).trim());
      }
    } else if (!combo.getAttribute('aria-label')) {
      combo.setAttribute('aria-label', 'Sort by');
    }
  }

  function optionsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[role="option"]'));
  }

  function isOpen(combo) {
    return combo.getAttribute('aria-expanded') === 'true';
  }

  function selectedOption(options) {
    return (
      options.find(function (el) {
        return el.getAttribute('aria-selected') === 'true' || el.classList.contains('link-dropdown__link--active');
      }) || options[0] || null
    );
  }

  function focusOption(combo, options, option) {
    if (!option) return;
    options.forEach(function (el, index) {
      el.classList.remove(FOCUS_CLASS);
      if (!el.id) el.id = 'sort-option-' + index;
    });
    option.classList.add(FOCUS_CLASS);
    combo.setAttribute('aria-activedescendant', option.id);
    if (option.scrollIntoView) {
      option.scrollIntoView({ block: 'nearest' });
    }
  }

  function openCombo(combo) {
    if (!isOpen(combo)) combo.click();
  }

  function closeCombo(combo) {
    if (isOpen(combo)) combo.click();
    combo.removeAttribute('aria-activedescendant');
    var root = combo.closest('link-dropdown');
    if (!root) return;
    optionsOf(root).forEach(function (el) {
      el.classList.remove(FOCUS_CLASS);
    });
  }

  function enhance(root) {
    var combo = root.querySelector('[role="combobox"], .link-dropdown__button');
    if (!combo) return;
    nameCombo(combo);
    if (combo.dataset.lfSortCombo === 'true') return;
    combo.dataset.lfSortCombo = 'true';

    optionsOf(root).forEach(function (el, index) {
      if (el.tabIndex !== -1) el.setAttribute('tabindex', '-1');
      if (!el.id) el.id = 'sort-option-' + index;
    });

    combo.addEventListener('keydown', function (event) {
      var options = optionsOf(root);
      if (!options.length) return;
      var key = event.key;
      var open = isOpen(combo);
      var currentId = combo.getAttribute('aria-activedescendant');
      var current = (currentId && document.getElementById(currentId)) || selectedOption(options);
      var index = options.indexOf(current);

      if (key === 'Tab') {
        if (open) closeCombo(combo);
        return;
      }

      if (!open && (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter' || key === ' ' || key === 'Spacebar')) {
        event.preventDefault();
        openCombo(combo);
        focusOption(combo, options, key === 'ArrowUp' ? options[options.length - 1] : selectedOption(options));
        return;
      }

      if (!open) return;

      if (key === 'ArrowDown') {
        event.preventDefault();
        focusOption(combo, options, options[Math.min(index + 1, options.length - 1)]);
        return;
      }

      if (key === 'ArrowUp') {
        event.preventDefault();
        focusOption(combo, options, options[Math.max(index - 1, 0)]);
        return;
      }

      if (key === 'Home') {
        event.preventDefault();
        focusOption(combo, options, options[0]);
        return;
      }

      if (key === 'End') {
        event.preventDefault();
        focusOption(combo, options, options[options.length - 1]);
        return;
      }

      if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
        event.preventDefault();
        if (current) current.click();
        return;
      }

      if (key === 'Escape') {
        event.preventDefault();
        closeCombo(combo);
        combo.focus();
      }
    });

    root.addEventListener('mouseover', function (event) {
      var option = event.target && event.target.closest && event.target.closest('[role="option"]');
      if (!option || !root.contains(option) || !isOpen(combo)) return;
      focusOption(combo, optionsOf(root), option);
    });
  }

  function scan() {
    document.querySelectorAll('link-dropdown').forEach(enhance);
  }

  window.lfA11y.once(scan);
})();

/* “Filter” button announced as a link and missing expanded/collapsed state */
(function () {
  function sync() {
    var host = document.querySelector('filter-container');
    var mobile = window.matchMedia('(max-width: 767.98px)').matches;
    var open = false;
    if (host) {
      open = mobile
        ? host.classList.contains('filter-container--show-filters-mobile')
        : host.classList.contains('filter-container--show-filters-desktop');
    }
    document.querySelectorAll('[data-toggle-filters].toggle-btn').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-toggle-filters]')) {
      setTimeout(sync, 0);
    }
  }, true);

  window.lfA11y.once(sync);
})();

/* “Date, new to old” button lacks an accessible “Sort by” name */
(function () {
  function scan() {
    var button = document.getElementById('sort-dropdown-button');
    var value = document.getElementById('sort-dropdown-value');
    if (button && value) {
      var current = value.textContent.replace(/\s+/g, ' ').trim();
      if (current) button.setAttribute('aria-label', 'Sort by ' + current);
    }
    document.querySelectorAll('#sort-dropdown-options [role="option"], input[name="sort_by"]').forEach(function (el) {
      var name = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!name) return;
      if (!/^sort by/i.test(name)) el.setAttribute('aria-label', 'Sort by ' + name.replace(/^sort by\s+/i, ''));
    });
  }

  window.lfA11y.once(scan);
})();

/* Unnecessary “For” landmark on collection pages */
(function () {
  function scan() {
    var form = document.getElementById('CollectionFilterForm');
    if (!form) return;
    var name = (form.getAttribute('aria-label') || '').trim();
    if (!name || /^for$/i.test(name)) form.setAttribute('aria-label', 'Filters');
  }

  window.lfA11y.once(scan);
})();

/* Sort notification is not announced when products are sorted */
(function () {
  function live() {
    var el = document.getElementById('lf-sort-status');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lf-sort-status';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  }

  document.addEventListener('click', function (event) {
    var opt = event.target.closest && event.target.closest('#sort-dropdown-options [role="option"], input[name="sort_by"]');
    if (!opt) return;
    var name = (opt.getAttribute('aria-label') || opt.textContent || '').replace(/^sort by\s+/i, '').trim();
    if (name) live().textContent = 'Sorted by ' + name;
  }, true);
})();
